


import { treeSelectedSitesActions } from './actions';
import { treeSelectionSiteMutations } from './mutations';
import { treeSelectedSitesGetters } from './getters';

const state = {
    treeSelectedSitesFleet: []
};
const actions = { ...treeSelectedSitesActions };
const mutations = { ...treeSelectionSiteMutations };
const getters = { ...treeSelectedSitesGetters };


// eslint-disable-next-line import/prefer-default-export
export const treeSelectedSitesStore = {
    namespaced: true,
    state, actions, mutations, getters,
};
